import { createReducer, on } from '@ngrx/store';
import * as AutomaticChargesActions from './automatic-charges.actions';

export interface AutomaticChargesState {
  response: any[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: any[] };
}

export const initialState: AutomaticChargesState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const automaticChargesReducer = createReducer(
  initialState,
  on(AutomaticChargesActions.loadAutomaticCharges, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AutomaticChargesActions.loadAutomaticChargesSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(AutomaticChargesActions.loadAutomaticChargesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AutomaticChargesActions.loadAutomaticChargesSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
